import React from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useStyles } from './styles';
import { removeNotification } from '../../store/slices/notifications';
import { IStore } from '../../store/types';

const ICONS: Record<string, React.ReactNode> = {
    success: <CheckCircleOutlineIcon />,
    error: <ErrorOutlineIcon />,
    warning: <WarningAmberOutlinedIcon />,
    info: <InfoOutlinedIcon />,
};

/** Toast stack under the header (top-right, full width on phones). Items are added by `setNotifications`. */
const Notifications = () => {
    const classes = useStyles();
    const notificationsList = useSelector<IStore, any[]>((state) => state.notifications.data);
    const dispatch = useDispatch();

    return (
        <div className={classes.notifications}>
            {notificationsList?.map((item) => (
                <div key={item.id} className={classNames(classes.wpapper, item.type)} role={item.type === 'error' ? 'alert' : 'status'}>
                    <span className={classes.icon} aria-hidden="true">{ICONS[item.type] ?? ICONS.info}</span>
                    <span className={classes.text}>{item?.text}</span>
                    <IconButton size="small" className={classes.close} onClick={() => dispatch(removeNotification(item.id))} aria-label="Dismiss">
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </div>
            ))}
        </div>
    );
};

export default Notifications;
